import { BrandConfig } from '../types';

export const betmgmConfig: BrandConfig = {
  id: 'betmgm',
  name: 'BetMGM',
  displayName: 'BetMGM',
  logo: 'BetMGM.svg',
  primaryColor: '#2196F3',
  categories: [
    {
      name: 'The Price Is Right',
      banner: 'banners/banner_TPIR.jpg',
      gamesPath: 'brands/betmgm.json',
      ipKeys: ['The Price Is Right'],
      brandIcon: 'logo_TPIR.png',
      comingSoon: false,
      disabled: false
    },
    {
      name: 'Family Feud',
      banner: 'banners/banner_FF.jpg',
      gamesPath: 'brands/betmgm.json',
      ipKeys: ['Family Feud'],
      brandIcon: 'logo_FF.png',
      comingSoon: false,
      disabled: false
    },
    {
      name: 'Survivor',
      banner: 'banners/banner_Survivor.jpg',
      gamesPath: 'brands/betmgm.json',
      ipKeys: ['Survivor'],
      brandIcon: 'logo_S.png',
      comingSoon: false,
      disabled: false
    },
    {
      name: "Let's Make a Deal",
      banner: 'banners/banner_LMAD.jpg',
      gamesPath: 'brands/betmgm.json',
      ipKeys: ["Let's Make a Deal"],
      brandIcon: 'logo_LMAD.png',
      comingSoon: false,
      disabled: false
    },
    {
      name: 'Big Brother',
      banner: 'banners/banner_bigbrother.jpg',
      gamesPath: 'brands/betmgm.json',
      ipKeys: ['Big Brother'],
      brandIcon: 'logo_BB.png',
      comingSoon: false,
      disabled: false
    },
    {
      name: 'Fear Factor',
      banner: 'banners/banner_fearfactor.jpg',
      gamesPath: 'brands/betmgm.json',
      ipKeys: ['Fear Factor'],
      brandIcon: 'logo_FFA.png',
      comingSoon: false,
      disabled: false
    },
    {
      name: 'Money Drop',
      banner: 'banners/banner_moneydrop.jpg',
      gamesPath: 'brands/betmgm.json',
      ipKeys: ['Money Drop'],
      brandIcon: 'logo_MD.png',
      comingSoon: false,
      disabled: false
    },
    {
      name: 'Traitors',
      banner: 'banners/banner_traitors.jpg',
      gamesPath: 'brands/betmgm.json',
      ipKeys: ['Traitors'],
      brandIcon: 'logo_traitors.png',
      comingSoon: false,
      disabled: false
    }
  ],
  defaultBanners: [
    'banners/banner_TPIR.jpg',
    'banners/banner_FF.jpg',
    'banners/banner_Survivor.jpg',
    'banners/banner_LMAD.jpg',
    'banners/banner_bigbrother.jpg',
    'banners/banner_fearfactor.jpg',
    'banners/banner_moneydrop.jpg',
    'banners/banner_traitors.jpg'
  ]
};

export const betmgmDemosOnlyConfig: BrandConfig = {
  id: 'betmgm-demos',
  name: 'BetMGM',
  displayName: 'BetMGM',
  logo: 'BetMGM.svg',
  primaryColor: '#2196F3',
  hideDisabled: true,
  categories: [
    {
      name: 'Survivor',
      banner: 'banners/banner_Survivor.jpg',
      gamesPath: 'brands/betmgm.json',
      ipKeys: ['Survivor'],
      brandIcon: 'logo_S.png',
      comingSoon: false,
      disabled: false
    },
  ],
  defaultBanners: [
    'banners/banner_Survivor.jpg',
  ]
}
